if (!customElements.get('bwww-collection-feed')) {
  customElements.define('bwww-collection-feed', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      this.grid = this.querySelector('[data-product-grid]');
      this.buttons = [...this.querySelectorAll('[data-load-more]')];
      this.status = this.querySelector('[role="status"]');
      this.loading = false;
      this.buttons.forEach(button => button.addEventListener('click', () => this.loadMore(button), {signal:this.abort.signal}));
      this.sync();
    }
    disconnectedCallback() { this.abort?.abort(); }
    sync() {
      this.buttons.forEach(button => {
        button.hidden = !this.dataset.nextUrl;
        button.disabled = this.loading;
        button.textContent = this.loading ? this.dataset.loading : this.dataset.more;
      });
      this.grid.setAttribute('aria-busy', String(this.loading));
    }
    async loadMore(trigger) {
      if (this.loading || !this.dataset.nextUrl) return;
      this.loading = true;
      this.status.textContent = '';
      this.sync();
      try {
        const url = new URL(this.dataset.nextUrl, window.location.href);
        if (url.origin !== window.location.origin) throw new Error('Unexpected origin');
        url.searchParams.set('section_id', this.dataset.sectionId);
        const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, {signal:this.abort.signal, credentials:'same-origin'});
        if (!response.ok) throw new Error('Request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const feed = [...doc.querySelectorAll('bwww-collection-feed')].find(item => item.dataset.sectionId === this.dataset.sectionId);
        if (!feed || Number(feed.dataset.page) !== Number(this.dataset.page) + 1) throw new Error('Unexpected page');
        const cards = [...feed.querySelectorAll('[data-product-grid] > [data-product-id]')];
        const ids = new Set([...this.grid.querySelectorAll('[data-product-id]')].map(card=>card.dataset.productId));
        if (!cards.length || cards.some(card=>ids.has(card.dataset.productId))) throw new Error('Collection changed');
        this.grid.append(...cards);
        this.dataset.page = feed.dataset.page;
        this.dataset.total = feed.dataset.total;
        this.dataset.nextUrl = feed.dataset.nextUrl || '';
        const shown = this.grid.querySelectorAll('[data-product-id]').length;
        this.status.textContent = this.dataset.statusTemplate.replace('[shown]',String(shown)).replace('[total]',this.dataset.total);
        if (!this.dataset.nextUrl) this.status.textContent += ' ' + this.dataset.complete;
        if (trigger.dataset.position === 'bottom' || !this.dataset.nextUrl) {
          cards[0].focus({preventScroll:true});
          cards[0].scrollIntoView({block:'start',behavior:'auto'});
        }
      } catch (error) {
        if (error.name !== 'AbortError') this.status.textContent = this.dataset.error;
      } finally {
        if (this.isConnected) { this.loading = false; this.sync(); }
      }
    }
  });
}
